
























































import Vue from 'vue'

import {ActiveFieldOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveField'
import {Dictionary} from 'vuex'
import {ActiveFormOptions} from '@/components/Ui/ActiveForm/BZCore/ActiveForm'
import StringField from '@/components/Ui/ActiveForm/BZCore/Fields/StringField'


export default Vue.extend({
  name: 'UiFiltersAndActions',
  data() {
    return {
      searchData: {search: ''},
      filtersData: {} as Dictionary<any>,
      searchInput: null as ActiveFormOptions | unknown,
      isFiltersOpen: false,
      isSearchFormOpen: false
    }
  },
  props: {
    hideFilters: Boolean,
    pageName: String,
    createBtnText: String,
    searchInputPlaceholder: String,
    searchFormButtonText: String,
    searchForm: Object as () => ActiveFormOptions | unknown,
    createFormPagePath: String,
    filters: Object as () => Dictionary<ActiveFieldOptions>,
    hiddenFilters: Object as () => Dictionary<ActiveFieldOptions>,
    defaultFilters: {
      type: Object as () => Dictionary<any>,
      default: () => {
        return {}
      }
    },
    hideHeader: Boolean,
    hideFooter: Boolean,
    hideBody: Boolean,
    resetFiltersText: String
  },
  created() {
    this.filtersData = this.defaultFilters
    if (!this.searchForm && this.searchInputPlaceholder) {
      this.searchInput = {
        inputs: {
          search: {
            type: StringField,
            placeholder: this.searchInputPlaceholder,
            options: {
              suffixIcon: {icon: 'search'}
            }
          }
        },
        steps: [
          {map: [['search']]}
        ]
      }
    }
  },
  methods: {
    onSearchInput(search: any) {
      this.$emit('searchChanged', search)
    },
    onInput(filtersData: any) {
      this.$emit('changed', filtersData)
    },
    resetFilters(): void {
      this.filtersData = {}
      this.searchData.search = ''
      this.onInput(this.filtersData)
      this.$emit('onFiltersReset', this.filtersData)
    },
    toggleFilters(): void {
      this.isFiltersOpen = !this.isFiltersOpen
    },
    toggleSearchForm(): void {
      this.isSearchFormOpen = !this.isSearchFormOpen
    }
  },
  computed: {
    filtersFormOptions(): ActiveFormOptions {
      const options: ActiveFormOptions = {
        inputs: this.filters,
        steps: [
          {map: [Object.keys(this.filters)]}
        ]
      }
      return options
    },
    hiddenFiltersFormOptions(): ActiveFormOptions {
      const options: ActiveFormOptions = {
        inputs: this.hiddenFilters,
        steps: [
          {map: [Object.keys(this.hiddenFilters)]}
        ]
      }
      return options
    },
    showResetButton(): boolean {
      let hasFilledKeys = false
      for (const filter in this.filtersData) {
        if (typeof this.filtersData[filter] === 'object') {
          if (this.filtersData[filter].length) {
            hasFilledKeys = true
          }
          continue;
        }
        if (this.filtersData[filter]) {
          hasFilledKeys = true
        }
      }
      if (this.searchData.search || hasFilledKeys) {
        return true
      }
      return false
    }
  },
  watch: {
    defaultFilters: {
      handler(val, oldval) {
        this.filtersData = this.defaultFilters
        this.onInput(val)
      },
      deep: true
    }
  }
})
